// generated from 489 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const censusCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("census_cohort_filter"),
  comparison_key: z.enum([
    "7", // 419 (85.69%)
    "8", // 70 (14.31%)
  ]),
  display_name: z.string(),
  // undefined: 464 (94.89%), defined 25 (5.11%)
  // format integer: 25 (100.00%)
  raw_value: z.string().optional(),
  value: z.object({
    // format integer: 489 (100.00%)
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
